// extracted by mini-css-extract-plugin
export default {"quoteBox":"Wrapper_quoteBox__pSDej"};